export function gtagHelper(product, similar) {
  const impressions = similar.map(p => productGAMapper(p));
     window.dataLayer.push({
       event: "detail",
       ecommerce: {
         detail: {
           products: [
             productGAMapper(product)
           ],
           impressions: impressions
         }
       }
     });
  //  delete products.SalePrice
}

export function productGAMapper(originalProduct) {
    let product = {...originalProduct}
    let price;
    if (product.OnSale) {
        price = product.SalePrice;
    } else {
        price = product.PriceB;
    }
    delete product.PriceB;
    delete product.SalePrice;

    return {
                id: product.id || product._id,
                name: product.Description,
                dimension4: product.Department,
                category: product.Category,
                size: product.Size,
                price: price,
                ...product
        };
}


// WEBPACK FOOTER //
// ./src/utils/gtagHelper.js